import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import DecimationReviewForm from './DecimationReviewForm'

function getModalStyle() {
    const top = 60;
    const left = 60;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-59%, -57%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        overflow: "scroll",
        position: 'absolute',
        width: "90%",
        height: "85%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function SimpleModal({ closeModal, removeModel, fileTitle, modelName, modelId, approveModel}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <DecimationReviewForm
                    closeModal={closeModal}
                    fileTitle={fileTitle}
                    removeModel={removeModel}
                    approveModel={approveModel}
                    modelName={modelName}
                    modelId={modelId} />
            </div>
        </Modal>
    );
}
